import React from 'react';
import { Assets } from 'components/assets/assets';
import Image from 'next/legacy/image';
import StoreButtons from 'components/store-buttons/store-buttons';
import Cta from 'components/cta/cta';
import ButtonGroup from 'components/button-group/button-group';
import Button from 'components/button/button';
import Icon from 'components/icon/icon';
import CtaAppButton from 'components/cta-app-button/cta-app-button';
import Header1 from 'components/typography/header-1';
import Header2 from 'components/typography/header-2';
import CtaBox, { CtaBoxAlign } from 'components/cta-box/cta-box';
import CtaBoxTitle, { CtaBoxTitleAlign } from 'components/cta-box/cta-box-title';
import CtaBoxMedia from 'components/cta-box/cta-box-media';
import { AnimationAppear } from 'components/animations/animations';

const faqUrl = 'https://bumble.com/help/what-is-bumble-night-in';

const APPSFLYER_LINKS = {
    CAMPAIGNS: {
        NIGHT_IN_TEASER: {
            APP_STORE: 'https://bumble.onelink.me/3396940749?pid=campaign&c=NightInMicrositeTeaser',
            GOOGLE_PLAY:
                'https://bumble.onelink.me/3396940749?pid=campaign&c=NightInMicrositeTeaser',
        },
        NIGHT_IN: {
            APP_STORE: 'https://bumble.onelink.me/3396940749?pid=campaign&c=NightInMicrositeUS',
            GOOGLE_PLAY: 'https://bumble.onelink.me/3396940749?pid=campaign&c=NightInMicrositeUS',
        },
        SAFETY_CENTER: {
            APP_STORE: 'https://bumble.onelink.me/3396940749?pid=campaign&c=safetycentermicrosite',
            GOOGLE_PLAY:
                'https://bumble.onelink.me/3396940749?pid=campaign&c=safetycentermicrosite',
        },
    },
};

const googlePlayButton = (
    <CtaAppButton
        market={CtaAppButton.market.GOOGLE_PLAY}
        href={APPSFLYER_LINKS.CAMPAIGNS.NIGHT_IN.GOOGLE_PLAY}
    />
);

const appStoreButton = (
    <CtaAppButton
        market={CtaAppButton.market.APP_STORE}
        href={APPSFLYER_LINKS.CAMPAIGNS.NIGHT_IN.APP_STORE}
    />
);

const appLinks = (
    <ButtonGroup size="sm">
        {googlePlayButton}
        {appStoreButton}
    </ButtonGroup>
);

const SecondaryText: React.FC<React.PropsWithChildren> = (props) => (
    <span className="text is-themed-text-secondary night-in">{props.children}</span>
);

export const slides = {
    one: {
        title: <Header1>A better way to date in virtually every way.</Header1>,
        media: (
            <Image
                className="cta-box__media-img"
                src={Assets.NIGHT_IN_TITLE}
                alt={''}
                layout={'responsive'}
                width={770}
                height={200}
                priority={true}
            />
        ),
        cta: (
            <Cta
                desktopAction={appLinks}
                mobileAction={
                    <StoreButtons androidButton={googlePlayButton} iosButton={appStoreButton} />
                }
            />
        ),
    },
    two: {
        title: (
            <Header1 extraClass="is-themed-text night-in">
                Team up for&nbsp;
                <SecondaryText>trivia</SecondaryText>
            </Header1>
        ),
        subTitle: <Header2>Getting to know your match is the real win.</Header2>,
        cta: '',
    },
    three: {
        title: <Header1>Every night from&nbsp;6pm</Header1>,
        subTitle: (
            <Header2>Choose a time together and we’ll remind you when it’s time to play.</Header2>
        ),
    },
    four: {
        title: (
            <Header1 extraClass="is-themed-text night-in">
                Think you’ve got&nbsp;<SecondaryText>game?</SecondaryText>
            </Header1>
        ),
        subTitle: <Header2>Schedule a Night In.</Header2>,
    },
    five: {
        title: <Header1>Dating can be fun and games.</Header1>,
        cta: (
            <Cta
                desktopAction={appLinks}
                mobileAction={
                    <StoreButtons androidButton={googlePlayButton} iosButton={appStoreButton} />
                }
            />
        ),
        ctaFAQ: (
            <Cta
                desktopAction={
                    <Button
                        icon={<Icon size="xsm" name={Icon.Name.QuestionCircle} />}
                        text="Night In FAQs"
                        href={faqUrl}
                    />
                }
                mobileAction={<Button text="Night In FAQs" href={faqUrl} />}
                mobileAlignCenter={true}
            />
        ),
    },
};
export const slidesCommonContent = {
    one: (
        <CtaBox align={CtaBoxAlign.CENTERED}>
            <CtaBoxMedia>
                <AnimationAppear y={50}>{slides.one.media}</AnimationAppear>
            </CtaBoxMedia>

            <CtaBoxTitle marginTop={16}>
                <AnimationAppear y={80}>{slides.one.title}</AnimationAppear>
            </CtaBoxTitle>
            <CtaBoxTitle marginTop={48}>
                <AnimationAppear y={90}>{slides.one.cta}</AnimationAppear>
            </CtaBoxTitle>
        </CtaBox>
    ),
    five: (
        <CtaBox align={CtaBoxAlign.CENTERED}>
            <CtaBoxTitle marginTop={16}>
                <AnimationAppear y={80}>{slides.five.title}</AnimationAppear>
            </CtaBoxTitle>
            <CtaBoxTitle marginTop={48}>
                <AnimationAppear y={90}>{slides.five.cta}</AnimationAppear>
            </CtaBoxTitle>
            <CtaBoxTitle align={CtaBoxTitleAlign.CENTERED} marginTop={24}>
                <AnimationAppear y={90}>{slides.five.ctaFAQ}</AnimationAppear>
            </CtaBoxTitle>
        </CtaBox>
    ),
};
